import { Injectable, inject } from '@angular/core';
import { ConfigProfile } from '../enums/config-profile.enum';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class CustomThemeService {
  private readonly appConfigService = inject(AppConfigService);

  setMerchantsCustomTheme(merchantId: string): Promise<void> {
    return new Promise((resolve) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href =
        this.appConfigService.config.profile === ConfigProfile.PROD
          ? `https://static.confirmo.net/theme/${merchantId}/style.css`
          : `https://static.cfmin.eu/theme/${merchantId}/style.css`;

      if (merchantId) {
        fetch(link.href, { method: 'HEAD' }).then((response) => {
          if (response.status === 200) {
            document.head.appendChild(link);
            resolve();
          } else {
            resolve();
          }
        });
      }
    });
  }
}
